/**
 * get last build timestamp from 'body data-t' html tag
 * @param {Array} htmlPage html page from which extract body tag
 * @return {String} last build timestamp
 */

const getLastBuildTimestamp = (htmlPage) => {
    try {
        return new DOMParser().parseFromString(htmlPage, 'text/html').body.getAttribute('data-t');
    } catch (error) {
        throw new Error(`Couldn't get last build timestamp due to error: ${error}`);
    }
};

export default getLastBuildTimestamp;